declare namespace $ {

	export class $mol_icon_artboard extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=artboard.view.tree.d.ts.map